"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _G2CSOTWZcjs = require('../__chunks/G2CSOTWZ.cjs');
require('../__chunks/UGAVMSQJ.cjs');
require('../__chunks/GDZQUFNP.cjs');
require('../__chunks/VC22SYOD.cjs');
require('../__chunks/I4CBIWTX.cjs');
require('../__chunks/WMTGHDLE.cjs');
require('../__chunks/4TRESXTO.cjs');


exports.createMenubarStore = _G2CSOTWZcjs.createMenubarStore;
